module.exports = __webpack_public_path__ + "img/Balance-4.e7f07830.jpg";